import { useAuth } from '../components/context/auth.context';
import AxiosService from './axios.service';
import { jwtDecode } from 'jwt-decode';

type JwtPayload = {
  exp: number; // tiempo de expiración en segundos
  iat: number; // tiempo de emisión
  [key: string]: any;
};

export type LoginResponse = {
  access_token: string;
  user: any;
};

export async function login(user: string, password: string) {
  try {
    const loginRequest = {
      user,
      password
    }
    const response = await AxiosService.post<LoginResponse>('/auth/login', loginRequest);
    if(response.status != 200)
      return null;
    return response;
  } catch (error : any) {
    alert(error)
    console.error("error" + error);
    return null;
  }
}

export function isUserLoggedIn(): boolean {
  console.log("validate login")
  const token = localStorage.getItem('token');
  if (!token || token == '') return false;
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    if (!decoded.exp) return false;
    const now = Date.now() / 1000; // en segundos
    return decoded.exp > now;
  } catch (error) {
    console.error('Error decoding token:', error);
    return false;
  }
}

export function logOut() {
  localStorage.setItem('token', '')
}